import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ws-soft-logo.png'
import _imports_1 from '@/assets/closeXBtn.png'
import _imports_2 from '@/assets/check.png'
import _imports_3 from '@/assets/check_color.png'


const _withScopeId = n => (_pushScopeId("data-v-54367c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc_wrap" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo_box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close_btn",
  src: _imports_1
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "doc_box box-border" }, [
  /*#__PURE__*/_createElementVNode("h2", null, " 우성소프트 프로그램 이용을 위해서는 이용약관 및 개인정보처리방침 동의가 필요합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "main_txt" }, " 개인정보보호법 및 관련 규정에 따라 이용자가 안심하고 서비스를 이용할 수 있도록 회사와 사용자가 준수해야할 지침 안내 ")
], -1))
const _hoisted_7 = { class: "doc_box bottom-box" }
const _hoisted_8 = { class: "doc_li flex-column" }
const _hoisted_9 = { class: "li_tit tit_1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "전체 동의하기", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 전체 동의는 주식회사 우성소프트의 서비스 이용약관, 서비스 개인정보처리방침, 마케팅 수신 동의를 포함하고 있습니다. 전체 동의는 선택 목적에 대한 동의를 포함하고 있으며, 선택 목적에 대한 동의를 거부해도 서비스 이용이 가능합니다. ", -1))
const _hoisted_12 = { class: "doc_li" }
const _hoisted_13 = { class: "li_tit" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "[필수] 우성소프트 서비스 이용약관", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("보기")
const _hoisted_16 = { class: "doc_li" }
const _hoisted_17 = { class: "li_tit" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "[필수] 우성소프트 개인정보처리방침", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("보기")
const _hoisted_20 = { class: "doc_li" }
const _hoisted_21 = { class: "li_tit" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "[선택] 우성소프트 마케팅 수신 동의", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("보기")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "close_box",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginPageMove()))
      }, _hoisted_5)
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.checkAllValue === 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.agreeAllCheck(1)))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_3,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreeAllCheck(0)))
              })),
          _hoisted_10
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.check_01 === 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_2,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.agreeCheck_01(1)))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_3,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.agreeCheck_01(0)))
              })),
          _hoisted_14
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, { to: "/doc_web/agreeItem_01" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.check_02 === 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_2,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.agreeCheck_02(1)))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_3,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.agreeCheck_02(0)))
              })),
          _hoisted_18
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, { to: "/doc_web/agreeItem_02" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.check_03 === 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_2,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.agreeCheck_03(1)))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_3,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.agreeCheck_03(0)))
              })),
          _hoisted_22
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, { to: "/doc_web/agreeItem_03" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["btn_agree", {
        active: _ctx.check_01 == 1 && _ctx.check_02 == 1,
      }]),
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.check_01 == 1 && _ctx.check_02 == 1 ? _ctx.postAgree() : ''))
    }, " 동의하고 계속하기 ", 2)
  ]))
}